"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapService = void 0;
class MapService {}
exports.MapService = MapService;